"use strict";

exports.__esModule = true;
var _ReportThumbnail = require("./ReportThumbnail");
Object.keys(_ReportThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportThumbnail[key]) return;
  exports[key] = _ReportThumbnail[key];
});